"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _constants = require("./constants");

var _defaults;

var defaults = (_defaults = {}, (0, _defineProperty2.default)(_defaults, _constants.MembershipEmailFields.id, null), (0, _defineProperty2.default)(_defaults, _constants.MembershipEmailFields.name, null), (0, _defineProperty2.default)(_defaults, _constants.MembershipEmailFields.subcategory, null), (0, _defineProperty2.default)(_defaults, _constants.MembershipEmailFields.emailTemplateMode, null), _defaults);

var MembershipEmail =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(MembershipEmail, _Record);

  function MembershipEmail() {
    (0, _classCallCheck2.default)(this, MembershipEmail);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MembershipEmail).apply(this, arguments));
  }

  (0, _createClass2.default)(MembershipEmail, [{
    key: "isDragAndDrop",
    value: function isDragAndDrop() {
      return this[_constants.MembershipEmailFields.emailTemplateMode] === _constants.EMAIL_TEMPLATE_TYPES.DRAG_AND_DROP;
    }
  }]);
  return MembershipEmail;
}((0, _immutable.Record)(defaults));

exports.default = MembershipEmail;
module.exports = exports.default;